import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { useState, useEffect, useRef } from 'react';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { PiWarningCircleBold } from 'react-icons/pi';
import { HiDotsVertical } from 'react-icons/hi';
import {
  IoSearchOutline,
  IoEyeOutline,
  IoChatbubbleEllipsesOutline,
} from 'react-icons/io5';
import { IoMdArrowDropdown } from 'react-icons/io';
import { RxCross2 } from 'react-icons/rx';
import { FiImage } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form, Dropdown } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ReactPaginate from 'react-paginate';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import {
  addContact,
  getAllContacts,
  searchContacts,
  updateContact,
  deleteContact,
  multipleDeleteContact,
  importContacts,
  createGroup,
  getAllGroups,
  deleteGroup,
  addContactToGroup,
  getTemplates,
  sendSingleMessage,
  getContactsOfGroup,
  uploadMedia,
} from '../../../../redux/actions/Chatbox.action';
import { BASEURL } from '../../../../baseUrl';

export default function Contacts() {
  const dispatch = useDispatch();
  const chatbox = useSelector((state) => state.chatbox);

  const [activeTab, setActiveTab] = useState('all'); // 'all' | 'groups'
  const [show, setShow] = useState(false);
  const [bulkModal, setBulkModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [contactId, setContactId] = useState('');
  const [selectedIds, setSelectedIds] = useState([]);
  const [mainPage, setMainPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const [formData, setFormData] = useState({});
  const [bulkFile, setBulkFile] = useState(null);
  const [isImporting, setIsImporting] = useState(false);
  const [groupModal, setGroupModal] = useState(false);
  const [groupDeleteModal, setGroupDeleteModal] = useState(false);
  const [groupContactsModal, setGroupContactsModal] = useState(false);
  const [groupSearch, setGroupSearch] = useState('');
  const [groupPage, setGroupPage] = useState(1);
  const [groupIdToDelete, setGroupIdToDelete] = useState('');
  const [activeGroup, setActiveGroup] = useState(null);
  const [groupSelectedContacts, setGroupSelectedContacts] = useState([]);
  const [groupName, setGroupName] = useState('');
  const [groupDescription, setGroupDescription] = useState('');

  const [groupModalTab, setGroupModalTab] = useState('new'); // 'new' | 'existing'
  const [existingGroupId, setExistingGroupId] = useState('');
  const [sendMessageModal, setSendMessageModal] = useState(false);
  const [sendMessageContact, setSendMessageContact] = useState(null);
  const [sendTemplateName, setSendTemplateName] = useState('');
  const [sendLanguage, setSendLanguage] = useState('');
  const [isSending, setIsSending] = useState(false);
  const [sendTemplateSearch, setSendTemplateSearch] = useState('');
  const [sendTemplateDropdownOpen, setSendTemplateDropdownOpen] =
    useState(false);
  const [selectedSendTemplate, setSelectedSendTemplate] = useState(null);
  const [sendVariables, setSendVariables] = useState([]); // [{ source, defaultValue }]
  const [headerImageFile, setHeaderImageFile] = useState(null);
  const [headerImagePreview, setHeaderImagePreview] = useState('');
  const [headerMediaId, setHeaderMediaId] = useState('');
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const [headerMediaType, setHeaderMediaType] = useState(''); // 'image' | 'video' | 'document'
  const headerFileInputRef = useRef(null);

  // Config per WhatsApp header format — controls accept, validation, labels
  const HEADER_MEDIA_CONFIG = {
    IMAGE: {
      type: 'image',
      accept: 'image/png,image/jpeg',
      allowedMimes: ['image/png', 'image/jpeg'],
      label: 'Upload image in PNG/JPG file',
      errorMessage: 'Only PNG or JPG images are allowed',
    },
    VIDEO: {
      type: 'video',
      accept: 'video/mp4,video/3gpp',
      allowedMimes: ['video/mp4', 'video/3gpp'],
      label: 'Upload video in MP4 file',
      errorMessage: 'Only MP4 videos are allowed',
    },
    DOCUMENT: {
      type: 'document',
      accept: 'application/pdf',
      allowedMimes: ['application/pdf'],
      label: 'Upload document in PDF file',
      errorMessage: 'Only PDF documents are allowed',
    },
  };
  const getHeaderMediaConfig = (headerFormat) =>
    HEADER_MEDIA_CONFIG[headerFormat] || HEADER_MEDIA_CONFIG.IMAGE;

  const toggle = () => setShow(!show);
  const bulkToggle = () => {
    setBulkModal(!bulkModal);
    setBulkFile(null);
  };
  const updateToggle = () => setUpdateModal(!updateModal);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  const groupToggle = () => {
    setGroupModal(!groupModal);
    setGroupName('');
    setGroupDescription('');
    setGroupSelectedContacts([]);
    setGroupModalTab('new');
    setExistingGroupId('');
  };
  const sendMessageToggle = () => {
    setSendMessageModal(!sendMessageModal);
    setSendTemplateName('');
    setSendLanguage('');
    setSendTemplateSearch('');
    setSendTemplateDropdownOpen(false);
    setSelectedSendTemplate(null);
    setSendVariables([]);
    setHeaderImageFile(null);
    setHeaderImagePreview('');
    setHeaderMediaId('');
    setIsUploadingImage(false);
    setHeaderMediaType('');
  };
  const groupDeleteToggle = () => setGroupDeleteModal(!groupDeleteModal);
  const groupContactsToggle = () => setGroupContactsModal(!groupContactsModal);

  const initialValues = { fname: '', lname: '', email: '', phoneNumber: '' };
  const validationSchema = Yup.object().shape({
    fname: Yup.string().required('First Name is required'),
    phoneNumber: Yup.string().required('Phone Number is required'),
  });

  const limits = { page: mainPage, limit: rowsPerPage, search: searchQuery };

  useEffect(() => {
    dispatch(getAllContacts(limits));
  }, [mainPage, rowsPerPage]);

  const groupLimits = { page: groupPage, limit: 10, search: groupSearch };
  useEffect(() => {
    if (activeTab === 'groups') {
      dispatch(getAllGroups(groupLimits));
    }
  }, [activeTab, groupPage, groupSearch]);

  useEffect(() => {
    dispatch(getAllGroups({ page: 1, limit: 100, search: '' }));
    dispatch(getTemplates({ status: 'APPROVED', limit: 1000 }));
  }, []);

  const handleAddContact = (values, { resetForm }) => {
    dispatch(addContact(values, limits)).then(() => {
      toggle();
      resetForm();
    });
  };

  const handleUpdateContact = (values) => {
    dispatch(updateContact(contactId, values, limits)).then(() => {
      setUpdateModal(false);
    });
  };

  const handleDeleteContact = () => {
    if (selectedIds.length > 0) {
      dispatch(multipleDeleteContact(selectedIds, limits)).then(() => {
        setSelectedIds([]);
        deleteToggle();
      });
    } else {
      dispatch(deleteContact(contactId, limits)).then(() => {
        deleteToggle();
      });
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    dispatch(searchContacts({ page: 1, limit: rowsPerPage, search: value }));
  };

  const ChangeMainPage = (selected) => {
    const newPage = parseInt(selected.selected) + 1;
    setMainPage(newPage);
    dispatch(
      searchContacts({
        page: newPage,
        limit: rowsPerPage,
        search: searchQuery,
      }),
    );
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setMainPage(1);
  };

  const handleCreateGroup = () => {
    if (!groupName.trim()) {
      toast.error('Group name is required');
      return;
    }
    const contactIds =
      selectedIds.length > 0 ? selectedIds : groupSelectedContacts;
    if (contactIds.length === 0) {
      toast.error('Select at least one contact');
      return;
    }
    dispatch(
      createGroup(
        {
          name: groupName,
          description: groupDescription,
          contactIds,
        },
        groupLimits,
      ),
    ).then(() => {
      groupToggle();
      setSelectedIds([]);
    });
  };
  const handleAddToExistingGroup = () => {
    if (!existingGroupId) {
      toast.error('Select a group');
      return;
    }
    const contactIds =
      selectedIds.length > 0 ? selectedIds : groupSelectedContacts;
    if (contactIds.length === 0) {
      toast.error('Select at least one contact');
      return;
    }
    dispatch(addContactToGroup(existingGroupId, contactIds, groupLimits)).then(
      () => {
        groupToggle();
        setSelectedIds([]);
      },
    );
  };
  const handleGroupContactToggle = (id) => {
    setGroupSelectedContacts((prev) =>
      prev.includes(id) ? prev.filter((c) => c !== id) : [...prev, id],
    );
  };
  const handleDeleteGroup = () => {
    dispatch(deleteGroup(groupIdToDelete, groupLimits)).then(() => {
      groupDeleteToggle();
    });
  };
  const openGroupContacts = (group) => {
    setActiveGroup(group);
    dispatch(getContactsOfGroup(group._id, { page: 1, limit: 50, search: '' }));
    groupContactsToggle();
  };

  const openSendMessage = (contact) => {
    setSendMessageContact(contact);
    sendMessageToggle();
  };
  const getComponentText = (template, type) => {
    const comp = template?.components?.find(
      (c) => c.type?.toUpperCase() === type,
    );
    return comp?.text || '';
  };
  const getComponentByType = (template, type) =>
    template?.components?.find((c) => c.type?.toUpperCase() === type);
  const handleSendTemplateSelect = (name) => {
    setSendTemplateName(name);
    setSendTemplateSearch(name);
    setSendTemplateDropdownOpen(false);
    const t = templateList.find((tpl) => tpl.name === name);
    setSelectedSendTemplate(t || null);
    if (t?.language) {
      setSendLanguage(t.language);
    }
    const bodyText = getComponentText(t, 'BODY');
    const matches = bodyText.match(/{{\d+}}/g) || [];
    setSendVariables(
      matches.map((_, idx) => ({
        source: idx === 0 ? 'First Name' : 'Custom',
        defaultValue: '',
      })),
    );
    setHeaderImageFile(null);
    setHeaderImagePreview('');
    setHeaderMediaId('');
    setHeaderMediaType('');
  };
  const handleHeaderImageChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const headerComp = getComponentByType(selectedSendTemplate, 'HEADER');
    const headerFormat = headerComp?.format?.toUpperCase() || 'IMAGE';
    const config = getHeaderMediaConfig(headerFormat);
    if (!config.allowedMimes.includes(file.type)) {
      toast.error(config.errorMessage);
      e.target.value = '';
      return;
    }
    setHeaderMediaType(config.type);
    setHeaderImageFile(file);
    setHeaderImagePreview(URL.createObjectURL(file));
    setHeaderMediaId('');
    setIsUploadingImage(true);
    dispatch(uploadMedia(file)).then((mediaId) => {
      setIsUploadingImage(false);
      if (mediaId) {
        setHeaderMediaId(mediaId);
        toast.success(
          `${config.type[0].toUpperCase()}${config.type.slice(1)} uploaded`,
        );
      } else {
        setHeaderImageFile(null);
        setHeaderImagePreview('');
        setHeaderMediaType('');
      }
    });
  };
  const updateSendVariable = (idx, field, value) => {
    setSendVariables((prev) => {
      const updated = [...prev];
      updated[idx] = { ...updated[idx], [field]: value };
      return updated;
    });
  };
  const resolveVariableValue = (variable) => {
    if (variable.source === 'First Name')
      return sendMessageContact?.fname || variable.defaultValue;
    if (variable.source === 'Last Name')
      return sendMessageContact?.lname || variable.defaultValue;
    if (variable.source === 'Phone Number')
      return sendMessageContact?.phoneNumber || variable.defaultValue;
    return variable.defaultValue;
  };

  const handleSendMessage = () => {
    if (!sendTemplateName) {
      toast.error('Please select a template');
      return;
    }
    const headerComp = getComponentByType(selectedSendTemplate, 'HEADER');
    const headerFormat = headerComp?.format?.toUpperCase();
    const headerNeedsMedia =
      headerComp &&
      (['IMAGE', 'VIDEO', 'DOCUMENT'].includes(headerFormat) ||
        !headerFormat ||
        /upload\s*(image|video|document|file)/i.test(
          getComponentText(selectedSendTemplate, 'HEADER') || '',
        ));
    if (headerNeedsMedia && !headerMediaId) {
      const mediaLabel = getHeaderMediaConfig(headerFormat).type;
      toast.error(`Please upload the header ${mediaLabel} before sending`);
      return;
    }
    setIsSending(true);
    dispatch(
      sendSingleMessage({
        to: sendMessageContact?.phoneNumber,
        templateName: sendTemplateName,
        languageCode: sendLanguage,
        parameters: {
          body: sendVariables.map(resolveVariableValue),
          ...(headerMediaId
            ? {
                header: {
                  type: headerMediaType || 'image',
                  value: headerMediaId,
                },
              }
            : {}),
        },
      }),
    ).then(() => {
      setIsSending(false);
      sendMessageToggle();
    });
  };

  const handleBulkFileChange = (e) => {
    setBulkFile(e.target.files[0]);
  };

  const handleBulkUpload = () => {
    if (!bulkFile) {
      toast.error('Please select a file to upload');
      return;
    }
    setIsImporting(true);
    const fd = new FormData();
    fd.append('excelFile', bulkFile);
    dispatch(importContacts(fd, limits)).then(() => {
      setIsImporting(false);
      bulkToggle();
    });
  };

  const handleDownloadSample = () => {
    // Static sample template download (client-side generated CSV)
    const sampleData =
      'firstName,lastName,email,phoneNumber\nJohn,Doe,john@example.com,+919999999999\n';
    const blob = new Blob([sampleData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Contacts_Sample_File.csv';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  const handleExport = () => {
    const token = localStorage.getItem('token');
    fetch(`${BASEURL}/chatbox/contact/export`, {
      headers: { authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((res) => {
        const rows = res?.data || [];
        if (!rows.length) {
          toast.error('No contacts to export');
          return;
        }
        const header = 'First Name,Last Name,Phone Number,Email\n';
        const csv = rows
          .map(
            (c) =>
              `${c.fname || ''},${c.lname || ''},${c.phoneNumber || ''},${c.email || ''}`,
          )
          .join('\n');
        const blob = new Blob([header + csv], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Contacts_Export.csv';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => toast.error('Export failed'));
  };

  const handleCheckbox = (e, id) => {
    setSelectedIds((prev) =>
      e.target.checked ? [...prev, id] : prev.filter((i) => i !== id),
    );
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedIds(contactList.map((c) => c._id));
    } else {
      setSelectedIds([]);
    }
  };

  const postPerPage = rowsPerPage;
  const PageCount = Math.ceil(
    chatbox?.getAllContacts?.data?.totalCount / postPerPage,
  );
  const contactList = chatbox?.getAllContacts?.data?.data || [];
  const totalRecords = chatbox?.getAllContacts?.data?.totalCount || 0;
  const groupList = chatbox?.getAllGroups?.data?.data || [];
  const groupTotalRecords = chatbox?.getAllGroups?.data?.totalCount || 0;
  const groupContactsList = chatbox?.getContactsOfGroup?.data?.data || [];
  const templateList = chatbox?.getTemplates?.data?.data?.data || [];
  const filteredSendTemplates = templateList.filter((t) =>
    t.name?.toLowerCase().includes(sendTemplateSearch.toLowerCase()),
  );

  return (
    <>
      <div className="mt-[100px]">
        <div
          className="bg-white rounded shadow-sm p-4"
          style={{ border: '1px solid #eee' }}
        >
          {/* Header row: Title + Tabs + Action buttons */}
          <div className="d-flex justify-content-between align-items-start flex-wrap gap-3 mb-3">
            <h3 className="fw-bold mb-0">Contacts</h3>

            <div className="d-flex flex-column align-items-end gap-2">
              <div className="d-flex align-items-center gap-2">
                {selectedIds.length > 0 && (
                  <>
                    <Button
                      onClick={deleteToggle}
                      size="sm"
                      className="bg-danger fw-bold border-0 rounded-pill px-3"
                    >
                      <MdDelete className="me-1" />
                      Delete Selected ({selectedIds.length})
                    </Button>
                    <Button
                      onClick={groupToggle}
                      size="sm"
                      className="fw-bold border-0 rounded-pill px-3"
                      style={{ background: '#0891b2' }}
                    >
                      + Add Group
                    </Button>
                  </>
                )}
                <Button
                  onClick={bulkToggle}
                  size="sm"
                  className="fw-bold border-0 rounded-pill px-3"
                  style={{ background: '#1a3a6b' }}
                >
                  Add Bulk Contact
                </Button>
                <Button
                  onClick={handleExport}
                  size="sm"
                  className="fw-bold border-0 rounded-pill px-3"
                  style={{ background: '#16a34a' }}
                >
                  Export Contacts
                </Button>
                <Button
                  onClick={toggle}
                  size="sm"
                  className="fw-bold border-0 rounded-pill px-3"
                  style={{ background: '#1e40af' }}
                >
                  + Add Contact
                </Button>
              </div>
              <span
                onClick={handleDownloadSample}
                className="text-primary small cursor-pointer"
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
              >
                Download Sample File
              </span>
            </div>
          </div>

          {/* Tabs: All Contacts / Groups */}
          <div className="d-flex gap-2 mb-4">
            <button
              onClick={() => setActiveTab('all')}
              className={`px-3 py-2 rounded fw-bold border-0 ${
                activeTab === 'all'
                  ? 'bg-light text-dark'
                  : 'bg-white text-muted'
              }`}
              style={{
                background: activeTab === 'all' ? '#e9ecef' : 'transparent',
              }}
            >
              Contacts
            </button>
            <button
              onClick={() => setActiveTab('groups')}
              className={`px-3 py-2 rounded fw-bold border-0 bg-white ${
                activeTab === 'groups' ? 'text-dark' : 'text-muted'
              }`}
              style={{
                background: activeTab === 'groups' ? '#e9ecef' : 'transparent',
              }}
            >
              Groups
            </button>
          </div>

          {activeTab === 'all' ? (
            <>
              {/* Search + Rows + Total Records — same line */}
              <div className="d-flex justify-content-end align-items-center gap-3 flex-wrap mb-3">
                <div
                  className="bg-white d-flex items-center gap-2 px-3 py-2 rounded-pill"
                  style={{ border: '1px solid #dee2e6', minWidth: '260px' }}
                >
                  <IoSearchOutline />
                  <input
                    type="text"
                    name="search"
                    value={searchQuery}
                    onChange={handleSearch}
                    className="w-100 outline-none border-0"
                    placeholder="Search here..."
                    style={{ outline: 'none', border: 'none' }}
                  />
                </div>
                <div
                  className="d-flex align-items-center gap-2 px-3 py-2 rounded-pill"
                  style={{ border: '1px solid #dee2e6' }}
                >
                  <select
                    value={rowsPerPage}
                    onChange={handleRowsPerPageChange}
                    className="border-0 outline-none bg-transparent"
                  >
                    <option value={10}>10 rows</option>
                    <option value={30}>30 rows</option>
                    <option value={50}>50 rows</option>
                    <option value={100}>100 rows</option>
                  </select>
                </div>
                <div
                  className="px-3 py-2 rounded-pill"
                  style={{ border: '1px solid #dee2e6' }}
                >
                  Total Records :{' '}
                  <span className="fw-bold">{totalRecords}</span>
                </div>
              </div>

              <TableContainer>
                <Table variant="simple">
                  <Thead>
                    <Tr style={{ borderBottom: '1px solid #eee' }}>
                      <Th>
                        <input
                          type="checkbox"
                          className="accent-theme-dark"
                          checked={
                            contactList.length > 0 &&
                            selectedIds.length === contactList.length
                          }
                          onChange={handleSelectAll}
                        />
                      </Th>
                      <Th>Full Name</Th>
                      <Th>Phone</Th>
                      <Th>Email</Th>
                      <Th>Created By</Th>
                      <Th className="text-end">Actions</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {contactList.length > 0 ? (
                      contactList.map((res) => (
                        <Tr
                          key={res._id}
                          style={{ borderBottom: '1px solid #f5f5f5' }}
                        >
                          <Td>
                            <input
                              type="checkbox"
                              className="accent-theme-dark"
                              checked={selectedIds.includes(res._id)}
                              onChange={(e) => handleCheckbox(e, res._id)}
                            />
                          </Td>
                          <Td className="fw-bold">
                            {res.fname} {res.lname}
                          </Td>
                          <Td>{res.phoneNumber}</Td>
                          <Td>{res.email || '-'}</Td>
                          <Td>{res?.created_by?.name || '-'}</Td>
                          <Td className="text-end">
                            <Dropdown align="end">
                              <Dropdown.Toggle className="bg-transparent border-0 p-0">
                                <HiDotsVertical className="text-dark fs-5" />
                              </Dropdown.Toggle>
                              <Dropdown.Menu
                                renderOnMount
                                popperConfig={{ strategy: 'fixed' }}
                              >
                                <Dropdown.Item
                                  onClick={() => openSendMessage(res)}
                                  className="d-flex gap-2"
                                >
                                  <IoChatbubbleEllipsesOutline className="text-primary" />{' '}
                                  Send Message
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onClick={() => {
                                    updateToggle();
                                    setFormData(res);
                                    setContactId(res._id);
                                  }}
                                  className="d-flex gap-2"
                                >
                                  <FaEdit className="text-success" /> Edit
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onClick={() => {
                                    setSelectedIds([]);
                                    setContactId(res._id);
                                    deleteToggle();
                                  }}
                                  className="d-flex gap-2"
                                >
                                  <MdDelete className="text-danger" /> Delete
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </Td>
                        </Tr>
                      ))
                    ) : (
                      <Tr>
                        <Td colSpan={6} textAlign="center">
                          Contact Not Found
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>

              <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={ChangeMainPage}
                pageRangeDisplayed={5}
                pageCount={PageCount || 0}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
                className="pagination mt-3"
              />
            </>
          ) : (
            <>
              <div className="d-flex justify-content-between align-items-center gap-3 flex-wrap mb-3">
                <Button
                  onClick={groupToggle}
                  className="fw-bold border-0 rounded-pill px-4"
                  style={{ background: '#1e40af' }}
                >
                  + Create Group
                </Button>
                <div className="d-flex align-items-center gap-3 flex-wrap">
                  <div
                    className="bg-white d-flex items-center gap-2 px-3 py-2 rounded-pill"
                    style={{ border: '1px solid #dee2e6', minWidth: '260px' }}
                  >
                    <IoSearchOutline />
                    <input
                      type="text"
                      value={groupSearch}
                      onChange={(e) => {
                        setGroupSearch(e.target.value);
                        setGroupPage(1);
                      }}
                      className="w-100 outline-none border-0"
                      placeholder="Search groups..."
                      style={{ outline: 'none', border: 'none' }}
                    />
                  </div>
                  <div
                    className="px-3 py-2 rounded-pill"
                    style={{ border: '1px solid #dee2e6' }}
                  >
                    Total Records :{' '}
                    <span className="fw-bold">{groupTotalRecords}</span>
                  </div>
                </div>
              </div>
              <TableContainer>
                <Table variant="simple">
                  <Thead>
                    <Tr style={{ borderBottom: '1px solid #eee' }}>
                      <Th>Group Name</Th>
                      <Th>Description</Th>
                      <Th>Contacts</Th>
                      <Th>Created By</Th>
                      <Th className="text-end">Actions</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {groupList.length > 0 ? (
                      groupList.map((g) => (
                        <Tr
                          key={g._id}
                          style={{ borderBottom: '1px solid #f5f5f5' }}
                        >
                          <Td className="fw-bold">{g.name}</Td>
                          <Td>{g.description || '-'}</Td>
                          <Td>{g.contactIds?.length || 0}</Td>
                          <Td>{g?.created_by?.name || '-'}</Td>
                          <Td className="text-end">
                            <Dropdown align="end">
                              <Dropdown.Toggle className="bg-transparent border-0 p-0">
                                <HiDotsVertical className="text-dark fs-5" />
                              </Dropdown.Toggle>
                              <Dropdown.Menu
                                renderOnMount
                                popperConfig={{ strategy: 'fixed' }}
                              >
                                <Dropdown.Item
                                  onClick={() => openGroupContacts(g)}
                                  className="d-flex gap-2"
                                >
                                  <IoEyeOutline className="text-primary" /> View
                                  Contacts
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onClick={() => {
                                    setGroupIdToDelete(g._id);
                                    groupDeleteToggle();
                                  }}
                                  className="d-flex gap-2"
                                >
                                  <MdDelete className="text-danger" /> Delete
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </Td>
                        </Tr>
                      ))
                    ) : (
                      <Tr>
                        <Td colSpan={5} textAlign="center">
                          Group Not Found
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            </>
          )}
        </div>
      </div>

      {/* Add Bulk Contact Modal */}
      <Modal show={bulkModal} onHide={bulkToggle}>
        <Modal.Header closeButton>
          <Modal.Title>Add Bulk Contact</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted small">
            Upload an Excel (.xlsx) file with your contacts. Download the sample
            file to see the required format.
          </p>
          <span
            onClick={handleDownloadSample}
            className="text-primary d-inline-block mb-3"
            style={{ textDecoration: 'underline', cursor: 'pointer' }}
          >
            Download Sample File
          </span>
          <Form.Group>
            <Form.Label>Upload File</Form.Label>
            <Form.Control
              type="file"
              accept=".xlsx"
              onChange={handleBulkFileChange}
              className="shadow-none focus:!border-theme-dark"
            />
            {bulkFile && (
              <div className="text-success small mt-2">
                Selected: {bulkFile.name}
              </div>
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={bulkToggle}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            Close
          </Button>
          <Button
            className="!bg-theme-dark border-0 px-4"
            onClick={handleBulkUpload}
            disabled={isImporting}
          >
            {isImporting ? 'Uploading...' : 'Upload'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Add Contact Modal */}
      <Modal show={show} onHide={toggle}>
        <Modal.Header closeButton>
          <Modal.Title>Add Contact</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleAddContact}
        >
          {({ handleSubmit, setFieldValue, values }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <Form.Group className="mb-3">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => setFieldValue('fname', e.target.value)}
                    value={values.fname}
                    placeholder="Enter First Name"
                    className="shadow-none focus:!border-theme-dark"
                  />
                  <ErrorMessage
                    name="fname"
                    component="div"
                    className="text-danger"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => setFieldValue('lname', e.target.value)}
                    value={values.lname}
                    placeholder="Enter Last Name"
                    className="shadow-none focus:!border-theme-dark"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    onChange={(e) => setFieldValue('email', e.target.value)}
                    value={values.email}
                    placeholder="Enter Email"
                    className="shadow-none focus:!border-theme-dark"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Phone Number</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) =>
                      setFieldValue('phoneNumber', e.target.value)
                    }
                    value={values.phoneNumber}
                    placeholder="+91XXXXXXXXXX"
                    className="shadow-none focus:!border-theme-dark"
                  />
                  <ErrorMessage
                    name="phoneNumber"
                    component="div"
                    className="text-danger"
                  />
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={toggle}
                  className="px-4 bg-transparent border-[1px] text-black border-green-color"
                >
                  Close
                </Button>
                <Button type="submit" className="!bg-theme-dark border-0 px-4">
                  Add
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>

      {/* Update Contact Modal */}
      <Modal show={updateModal} onHide={updateToggle}>
        <Modal.Header closeButton>
          <Modal.Title>Update Contact</Modal.Title>
        </Modal.Header>
        <Formik
          enableReinitialize
          initialValues={formData}
          validationSchema={validationSchema}
          onSubmit={handleUpdateContact}
        >
          {({ handleSubmit, setFieldValue, values }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <Form.Group className="mb-3">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => setFieldValue('fname', e.target.value)}
                    value={values.fname}
                    className="shadow-none focus:!border-theme-dark"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => setFieldValue('lname', e.target.value)}
                    value={values.lname}
                    className="shadow-none focus:!border-theme-dark"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    onChange={(e) => setFieldValue('email', e.target.value)}
                    value={values.email}
                    className="shadow-none focus:!border-theme-dark"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Phone Number</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) =>
                      setFieldValue('phoneNumber', e.target.value)
                    }
                    value={values.phoneNumber}
                    className="shadow-none focus:!border-theme-dark"
                  />
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={updateToggle}
                  className="px-4 bg-transparent border-[1px] text-black border-green-color"
                >
                  Close
                </Button>
                <Button type="submit" className="!bg-theme-dark border-0 px-4">
                  Update
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>

      {/* Delete Confirmation */}
      <Modal show={deleteModal} onHide={deleteToggle}>
        <Modal.Body className="p-5">
          <PiWarningCircleBold className="text-7xl w-100 text-danger" />
          <div className="text-center mt-4">
            <h3>Are You Sure ?</h3>
            <p className="text-md">
              Do you really want to delete these records?
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={deleteToggle}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            No
          </Button>
          <Button
            type="submit"
            className="bg-danger border-0 px-4"
            onClick={handleDeleteContact}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Create Group Modal */}
      <Modal show={groupModal} onHide={groupToggle}>
        <Modal.Header closeButton>
          <Modal.Title>Create Group</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="d-flex gap-2 mb-3 bg-light rounded p-1"
            style={{ border: '1px solid #dee2e6' }}
          >
            <button
              type="button"
              onClick={() => setGroupModalTab('new')}
              className={`flex-fill px-3 py-2 rounded fw-bold border-0 ${
                groupModalTab === 'new'
                  ? 'bg-white text-dark'
                  : 'bg-transparent text-muted'
              }`}
            >
              New Group
            </button>
            <button
              type="button"
              onClick={() => setGroupModalTab('existing')}
              className={`flex-fill px-3 py-2 rounded fw-bold border-0 ${
                groupModalTab === 'existing'
                  ? 'bg-white text-dark'
                  : 'bg-transparent text-muted'
              }`}
            >
              Add To Existing
            </button>
          </div>
          {selectedIds.length > 0 && (
            <div className="text-muted small mb-3">
              Using {selectedIds.length} contact(s) selected from the table.
            </div>
          )}
          {groupModalTab === 'new' ? (
            <>
              <Form.Group className="mb-3">
                <Form.Label>Group Name *</Form.Label>
                <Form.Control
                  type="text"
                  value={groupName}
                  onChange={(e) => setGroupName(e.target.value)}
                  placeholder="Enter Group Name"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={groupDescription}
                  onChange={(e) => setGroupDescription(e.target.value)}
                  placeholder="Enter Group Description (Optional)"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
              {selectedIds.length === 0 && (
                <Form.Group>
                  <Form.Label>
                    Select Contacts ({groupSelectedContacts.length} selected)
                  </Form.Label>
                  <div
                    style={{ maxHeight: '220px', overflowY: 'auto' }}
                    className="border rounded p-2"
                  >
                    {contactList.map((c) => (
                      <Form.Check
                        key={c._id}
                        type="checkbox"
                        label={`${c.fname} ${c.lname || ''} (${c.phoneNumber})`}
                        checked={groupSelectedContacts.includes(c._id)}
                        onChange={() => handleGroupContactToggle(c._id)}
                      />
                    ))}
                  </div>
                </Form.Group>
              )}
            </>
          ) : (
            <>
              <Form.Group className="mb-3">
                <Form.Label>Select Group *</Form.Label>
                <Form.Select
                  value={existingGroupId}
                  onChange={(e) => setExistingGroupId(e.target.value)}
                  className="shadow-none focus:!border-theme-dark"
                >
                  <option value="">Select a group</option>
                  {groupList.map((g) => (
                    <option key={g._id} value={g._id}>
                      {g.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              {selectedIds.length === 0 && (
                <Form.Group>
                  <Form.Label>
                    Select Contacts ({groupSelectedContacts.length} selected)
                  </Form.Label>
                  <div
                    style={{ maxHeight: '220px', overflowY: 'auto' }}
                    className="border rounded p-2"
                  >
                    {contactList.map((c) => (
                      <Form.Check
                        key={c._id}
                        type="checkbox"
                        label={`${c.fname} ${c.lname || ''} (${c.phoneNumber})`}
                        checked={groupSelectedContacts.includes(c._id)}
                        onChange={() => handleGroupContactToggle(c._id)}
                      />
                    ))}
                  </div>
                </Form.Group>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={groupToggle}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            Cancel
          </Button>
          <Button
            className="!bg-theme-dark border-0 px-4"
            onClick={
              groupModalTab === 'new'
                ? handleCreateGroup
                : handleAddToExistingGroup
            }
          >
            {groupModalTab === 'new' ? 'Create Group' : 'Add To Group'}
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Group Delete Confirmation */}
      <Modal show={groupDeleteModal} onHide={groupDeleteToggle}>
        <Modal.Body className="p-5">
          <PiWarningCircleBold className="text-7xl w-100 text-danger" />
          <div className="text-center mt-4">
            <h3>Are You Sure ?</h3>
            <p className="text-md">Do you really want to delete this group?</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={groupDeleteToggle}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            No
          </Button>
          <Button
            className="bg-danger border-0 px-4"
            onClick={handleDeleteGroup}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Group Contacts List */}
      <Modal show={groupContactsModal} onHide={groupContactsToggle}>
        <Modal.Header closeButton>
          <Modal.Title>Contacts — {activeGroup?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {groupContactsList.length > 0 ? (
            groupContactsList.map((c) => (
              <div
                key={c._id}
                className="d-flex justify-content-between border-bottom py-2"
              >
                <span>
                  {c.fname} {c.lname}
                </span>
                <span className="text-muted">{c.phoneNumber}</span>
              </div>
            ))
          ) : (
            <div className="text-center text-muted py-3">
              No contacts in this group
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={groupContactsToggle}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Send Message Modal */}
      <Modal
        show={sendMessageModal}
        onHide={sendMessageToggle}
        size="lg"
        centered
      >
        <Modal.Header
          closeButton
          style={{ background: '#12266b', color: '#fff', border: 'none' }}
        >
          <Modal.Title style={{ color: '#fff' }}>
            Send Message Using Template
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="d-flex" style={{ minHeight: '360px' }}>
            {/* Left: searchable template select */}
            <div
              style={{ width: '38%', borderRight: '1px solid #eee' }}
              className="p-3"
            >
              <Form.Label className="fw-bold">Select Template</Form.Label>
              <div style={{ position: 'relative' }}>
                <div
                  className="d-flex align-items-center rounded"
                  style={{ border: '1px solid #ced4da' }}
                >
                  <input
                    type="text"
                    value={sendTemplateSearch}
                    onChange={(e) => {
                      setSendTemplateSearch(e.target.value);
                      setSendTemplateDropdownOpen(true);
                    }}
                    onFocus={() => setSendTemplateDropdownOpen(true)}
                    placeholder="Search template..."
                    className="form-control border-0 shadow-none"
                  />
                  {sendTemplateSearch && (
                    <RxCross2
                      className="mx-2 text-muted"
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setSendTemplateSearch('');
                        setSendTemplateName('');
                        setSelectedSendTemplate(null);
                        setSendVariables([]);
                      }}
                    />
                  )}
                  <IoMdArrowDropdown
                    className="mx-2 text-muted"
                    style={{ cursor: 'pointer' }}
                    onClick={() => setSendTemplateDropdownOpen((o) => !o)}
                  />
                </div>
                {sendTemplateDropdownOpen && (
                  <div
                    className="bg-white shadow rounded mt-1"
                    style={{
                      maxHeight: '260px',
                      overflowY: 'auto',
                      border: '1px solid #eee',
                    }}
                  >
                    {filteredSendTemplates.length > 0 ? (
                      filteredSendTemplates.map((t) => (
                        <div
                          key={t.id || t.name}
                          onClick={() => handleSendTemplateSelect(t.name)}
                          className="px-3 py-2"
                          style={{
                            cursor: 'pointer',
                            background:
                              sendTemplateName === t.name
                                ? '#1e40af'
                                : 'transparent',
                            color:
                              sendTemplateName === t.name ? '#fff' : '#212529',
                          }}
                        >
                          {t.name}
                        </div>
                      ))
                    ) : (
                      <div className="px-3 py-2 text-muted">
                        No templates found
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
            {/* Right: live preview */}
            <div style={{ width: '62%' }} className="p-3">
              {selectedSendTemplate ? (
                <>
                  <div className="fw-bold mb-3">
                    {selectedSendTemplate.name} (
                    {sendLanguage || selectedSendTemplate.language})
                  </div>
                  {(() => {
                    const headerComp = getComponentByType(
                      selectedSendTemplate,
                      'HEADER',
                    );
                    if (!headerComp) return null;
                    const headerFormat = headerComp?.format?.toUpperCase();
                    const headerText = getComponentText(
                      selectedSendTemplate,
                      'HEADER',
                    );
                    const isPlaceholderMediaText = /upload\s*image/i.test(
                      headerText || '',
                    );
                    const isMediaFormat = [
                      'IMAGE',
                      'VIDEO',
                      'DOCUMENT',
                    ].includes(headerFormat);
                    const isTextHeader =
                      headerFormat === 'TEXT' &&
                      !!headerText &&
                      !isPlaceholderMediaText;
                    if (isTextHeader) {
                      return (
                        <>
                          <div className="fw-bold mb-2">Header</div>
                          <div className="mb-3">{headerText}</div>
                        </>
                      );
                    }
                    if (
                      isMediaFormat ||
                      isPlaceholderMediaText ||
                      !headerFormat
                    ) {
                      const resolvedFormat = isMediaFormat
                        ? headerFormat
                        : 'IMAGE';
                      const config = getHeaderMediaConfig(resolvedFormat);
                      const isVideo = config.type === 'video';
                      return (
                        <>
                          <div className="fw-bold mb-2">Header</div>
                          <input
                            type="file"
                            accept={config.accept}
                            ref={headerFileInputRef}
                            onChange={handleHeaderImageChange}
                            style={{ display: 'none' }}
                          />
                          <div
                            onClick={() => headerFileInputRef.current?.click()}
                            className="d-flex flex-column align-items-center justify-content-center rounded mb-3 text-muted"
                            style={{
                              height: '100px',
                              background:
                                headerImagePreview && !isVideo
                                  ? `url(${headerImagePreview}) center/cover no-repeat`
                                  : '#f6f7fb',
                              border: '1px dashed #ced4da',
                              cursor: 'pointer',
                              position: 'relative',
                              overflow: 'hidden',
                            }}
                          >
                            {!headerImagePreview && (
                              <>
                                <FiImage className="fs-3 mb-1" />
                                <span className="small fw-bold">
                                  {isUploadingImage ? 'Uploading...' : 'Browse'}
                                </span>
                                <span className="small">{config.label}</span>
                              </>
                            )}
                            {headerImagePreview && isVideo && (
                              <video
                                src={headerImagePreview}
                                muted
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                }}
                              />
                            )}
                            {headerImagePreview && isUploadingImage && (
                              <div
                                className="d-flex align-items-center justify-content-center w-100 h-100 text-white small fw-bold"
                                style={{
                                  background: 'rgba(0,0,0,0.5)',
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                }}
                              >
                                Uploading...
                              </div>
                            )}
                            {headerImagePreview &&
                              !isUploadingImage &&
                              headerMediaId && (
                                <div
                                  className="d-flex align-items-center justify-content-center w-100 h-100 text-white small fw-bold"
                                  style={{
                                    background: 'rgba(0,0,0,0.35)',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                  }}
                                >
                                  Click to change
                                </div>
                              )}
                          </div>
                        </>
                      );
                    }
                    return null;
                  })()}
                  <div className="fw-bold mb-2">Body</div>
                  <div
                    className="mb-3 text-muted"
                    style={{ whiteSpace: 'pre-line' }}
                  >
                    {getComponentText(selectedSendTemplate, 'BODY')}
                  </div>
                  {getComponentText(selectedSendTemplate, 'FOOTER') && (
                    <div className="text-muted small mb-3 fst-italic">
                      {getComponentText(selectedSendTemplate, 'FOOTER')}
                    </div>
                  )}
                  {sendVariables.length > 0 && (
                    <>
                      <div className="fw-bold mb-2">Variables</div>
                      {sendVariables.map((v, idx) => (
                        <div
                          key={idx}
                          className="d-flex gap-2 mb-2 align-items-center"
                        >
                          <span
                            className="text-muted"
                            style={{ minWidth: '38px' }}
                          >
                            {`{{${idx + 1}}}`}
                          </span>
                          <Form.Select
                            size="sm"
                            value={v.source}
                            onChange={(e) =>
                              updateSendVariable(idx, 'source', e.target.value)
                            }
                            className="shadow-none focus:!border-theme-dark"
                            style={{ maxWidth: '160px' }}
                          >
                            <option value="First Name">First Name</option>
                            <option value="Last Name">Last Name</option>
                            <option value="Phone Number">Phone Number</option>
                            <option value="Custom">Custom</option>
                          </Form.Select>
                          <Form.Control
                            size="sm"
                            type="text"
                            placeholder="Default"
                            value={v.defaultValue}
                            onChange={(e) =>
                              updateSendVariable(
                                idx,
                                'defaultValue',
                                e.target.value,
                              )
                            }
                            className="shadow-none focus:!border-theme-dark"
                          />
                        </div>
                      ))}
                    </>
                  )}
                </>
              ) : (
                <div className="text-muted d-flex align-items-center justify-content-center h-100">
                  Select a template to preview
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="text-muted small me-auto">
            To: {sendMessageContact?.fname} {sendMessageContact?.lname} (
            {sendMessageContact?.phoneNumber})
          </div>
          <Button
            variant="secondary"
            onClick={sendMessageToggle}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            Close
          </Button>
          <Button
            className="!bg-theme-dark border-0 px-4"
            onClick={handleSendMessage}
            disabled={isSending || !sendTemplateName}
          >
            {isSending ? 'Sending...' : 'Send Message'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
